<ub-card [rounded]="true" [dividers]="false">
  <h3 title>{{ bookingItemOption.title }}</h3>
  <div content>

    <ub-label *ngIf="bookingItemOption.summary.bookingDates?.min" label="Date" i18n-label>
        <span text>
          {{ bookingItemOption.summary.bookingDates | easDateRange: timezone: bookingItemOption.bookingDates?.timezone }}
        </span>
    </ub-label>

    <ub-label *ngIf="bookingItemOption.summary.bookingWindow?.min" label="Booking window" i18n-label>
      <span text>
        {{ bookingItemOption.summary.bookingWindow | easDateRange: timezone: bookingItemOption.bookingWindow?.timezone }}
      </span>
    </ub-label>

    <div *ngIf="options?.showCapacityInfo">
      <ub-label *ngIf="bookingItemOption.summary.openOptions" label="Booking status" text="OPEN" variant="success" i18n-label i18n-text></ub-label>
      <ub-label *ngIf="!bookingItemOption.summary.openOptions" label="Booking status" text="CLOSED" i18n-label i18n-text></ub-label>
      <ub-label *ngIf="bookingItemOption.summary.openOptions" label="Open options" i18n-label>
        <span text>
          {{ bookingItemOption.summary.openOptions }}
        </span>
      </ub-label>
    </div>

    <ub-label *ngIf="bookingItemOption.summary.price.min !== null" label="Price" i18n-label>
      <span text>{{ bookingItemOption.summary.price| easPriceRange: bookingItemOption.summary.price.currency }}</span>
    </ub-label>

    <ub-label *ngIf="bookingItemOption.venue" label="Venue" i18n-label>
      <span text>{{ bookingItemOption.venue?.name}}</span>
    </ub-label>

    <ub-label *ngIf="!bookingItemOption.summary.eligible">
      <span text>
        <span *ngIf="bookingItemOption.summary.eligible" class="met" i18n>Eligible</span>
        <span *ngIf="!bookingItemOption.summary.eligible" class="unmet" i18n>Not Eligible</span>
      </span>
    </ub-label>

    <ub-label *ngIf="bookingItemOption.eligibilityResult && !bookingItemOption.eligibilityResult?.overall"
      label="Reason" i18n-label>
      <span text [innerHtml]="bookingItemOption.eligibilityResult.reason"></span>
    </ub-label>

    <div *ngIf="!options?.showCapacityInfo">
      <ub-label *ngIf="capacityInfo$ | async; let capacityInfo"
        label="Availability" i18n-label>
        <span text [ngClass]="{'met': capacityInfo.free > 0, 'unmet': capacityInfo.free === 0}">
          {{ capacityInfo.free }}
        </span>
      </ub-label>
    </div>

    <div *ngIf="options?.showCapacityInfo && bookingItemOption.used_capacity">
      <ng-container i18n>Capacity</ng-container>
      <div *ngIf="bookingItemOption.used_capacity.available === -1" i18n>
        Maximum capacity has not been specified
      </div>

      <ul *ngIf="bookingItemOption.used_capacity.available !== -1">
        <li i18n>Maximum capacity: {{ bookingItemOption.used_capacity.available }}</li>
        <li i18n>Number of availability: {{ bookingItemOption.used_capacity.free }}</li>
      </ul>
      <!-- <ul *ngIf="options?.showCapacityInfo">
        <li i18n>Number of pending: {{ bookingItemOption.used_capacity.in_progress }}</li>
        <li i18n>Number of reserved: {{ bookingItemOption.used_capacity.temporary_reserved }}</li>
        <li i18n>Number of confirmed bookings: {{ bookingItemOption.used_capacity.confirmed }}</li>
        <li i18n>Number of all bookings: {{ bookingItemOption.used_capacity.all }}</li>
      </ul> -->
    </div>
  </div>

  <div actions>
    <eas-buttons-list *ngIf="buttons"
                      [buttons]="buttons"
                      [disabled]="false"
                      [processing]="isOperationInProgress"></eas-buttons-list>
  </div>
</ub-card>
